var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9994 22.9997C45.9994 10.3039 35.6955 0 22.9997 0C10.3039 0 0 10.3039 0 22.9997C0 34.1315 7.91189 43.4004 18.3997 45.5394V29.8996H13.7998V22.9997H18.3997V17.2498C18.3997 12.8108 22.0107 9.19987 26.4496 9.19987H32.1996V16.0998H27.5996C26.3346 16.0998 25.2997 17.1348 25.2997 18.3997V22.9997H32.1996V29.8996H25.2997V45.8844C36.9145 44.7344 45.9994 34.9365 45.9994 22.9997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFacebook);
export default __webpack_public_path__ + "static/media/icono_facebook.a6cfb9f6c4aac65cde24754f1aa9e6d3.svg";
export { ForwardRef as ReactComponent };